export const CALCULATOR_CONTENT = {
  title: 'Skorzystaj z kalkulatora, aby&nbsp;poznać swoją ofertę finansowania',
  currency: 'PLN',
  thumbWidth: 30,
  amount: {
    min: 5000,
    max: 150000,
    step: 5000,
    start: 110000,
    percent: 0.175
  },
  dates: {
    startRepaymentTerm: 12,
    startRepaymentMaxTerm: 1
  }
}
